import request from '@/utils/request';

const BASE = '/pm/archives';

// ---------------- 项目 ----------------
export const areaApi = {
  page: (params) => request.get(`${BASE}/area`, { params }),
  options: () => request.get(`${BASE}/area/options`),
  detail: (id) => request.get(`${BASE}/area/${id}`),
  create: (data) => request.post(`${BASE}/area`, data),
  update: (id, data) => request.put(`${BASE}/area/${id}`, data),
  changeStatus: (id, status) => request.patch(`${BASE}/area/${id}/status`, null, { params: { status } }),
  configBilling: (id, data) => request.put(`${BASE}/area/${id}/billing`, data),
  remove: (id) => request.delete(`${BASE}/area/${id}`)
};

// ---------------- 网格 ----------------
export const gridApi = {
  tree: (projectId) => request.get(`${BASE}/grid/tree`, { params: { projectId } }),
  create: (data) => request.post(`${BASE}/grid`, data),
  update: (id, data) => request.put(`${BASE}/grid/${id}`, data),
  remove: (id) => request.delete(`${BASE}/grid/${id}`),
  changeOwner: (id, ownerUserId) => request.patch(`${BASE}/grid/${id}/owner`, null, { params: { ownerUserId } }),
  assignRooms: (id, data) => request.post(`${BASE}/grid/${id}/rooms`, data)
};

// ---------------- 房间 ----------------
export const roomApi = {
  page: (params) => request.get(`${BASE}/room`, { params }),
  detail: (id) => request.get(`${BASE}/room/${id}`),
  create: (data) => request.post(`${BASE}/room`, data),
  update: (id, data) => request.put(`${BASE}/room/${id}`, data),
  batchStatus: (data) => request.patch(`${BASE}/room/batch/status`, data),
  batchGrid: (data) => request.patch(`${BASE}/room/batch/grid`, data),
  changeArea: (id, data) => request.patch(`${BASE}/room/${id}/area`, data),
  transfer: (id, data) => request.post(`${BASE}/room/${id}/transfer`, data),
  remove: (id, reason) => request.delete(`${BASE}/room/${id}`, { params: { reason } }),
  recycle: () => request.get(`${BASE}/room/recycle`),
  restore: (id) => request.post(`${BASE}/room/recycle/${id}/restore`),
  history: (id) => request.get(`${BASE}/room/${id}/history`),
  transfers: (id) => request.get(`${BASE}/room/${id}/transfers`)
};

// ---------------- 客户 ----------------
export const customerApi = {
  page: (params) => request.get(`${BASE}/customer`, { params }),
  detail: (id) => request.get(`${BASE}/customer/${id}`),
  rooms: (id) => request.get(`${BASE}/customer/${id}/rooms`),
  create: (data) => request.post(`${BASE}/customer`, data),
  update: (id, data) => request.put(`${BASE}/customer/${id}`, data),
  blacklist: (id, blacklist, reason) =>
    request.post(`${BASE}/customer/${id}/blacklist`, null, { params: { blacklist, reason } }),
  bindWechat: (id, openid) => request.post(`${BASE}/customer/${id}/wechat-bind`, null, { params: { openid } }),
  transfer: (data) => request.post(`${BASE}/customer/transfer`, data),
  bindRoom: (id, roomId) => request.post(`${BASE}/customer/${id}/bind-room`, null, { params: { roomId } }),
  unbindRoom: (id, roomId) => request.delete(`${BASE}/customer/${id}/unbind-room/${roomId}`)
};

// ---------------- 仪表 ----------------
export const meterApi = {
  page: (params) => request.get(`${BASE}/meter`, { params }),
  detail: (id) => request.get(`${BASE}/meter/${id}`),
  create: (data) => request.post(`${BASE}/meter`, data),
  update: (id, data) => request.put(`${BASE}/meter/${id}`, data),
  markStatus: (id, abnormal) => request.patch(`${BASE}/meter/${id}/status`, null, { params: { abnormal } }),
  replace: (id, data) => request.post(`${BASE}/meter/${id}/replace`, data),
  qrcodeUrl: (id, mobileBaseUrl) => `/api${BASE}/meter/${id}/qrcode?mobileBaseUrl=${encodeURIComponent(mobileBaseUrl || '')}`,
  mobileEntryQrUrl: (mobileBaseUrl, projectId, issuedAt) => `/api${BASE}/meter/mobile-entry-qrcode?mobileBaseUrl=${encodeURIComponent(mobileBaseUrl || '')}&projectId=${encodeURIComponent(projectId || '')}&issuedAt=${encodeURIComponent(issuedAt || '')}`
};

// ---------------- 字典 ----------------
export const dictApi = {
  list: (code) => request.get(`/common/dict/${code}`)
};
